module.exports = __webpack_public_path__ + "daf38afa659ca0adf334031000b871bf.svg";